module.exports = __webpack_public_path__ + "img/abcnews.1f71b86e.png";